import { AiConfigLabels } from "./aiConfig.types";

type Ts = (key: string, options?: Record<string, unknown>) => string;

export const buildAiConfigLabels = (ts: Ts): AiConfigLabels => ({
	configurationTitle: ts("aiConfig.configurationTitle"),
	promptLabel: ts("aiConfig.promptLabel"),
	promptPlaceholder: ts("aiConfig.promptPlaceholder"),
	promptHelp: ts("aiConfig.promptHelp"),
	promptMeta: ts("aiConfig.promptMeta"),
	defaultPrompt: ts("aiConfig.defaultPrompt"),
	insertVariable: ts("aiConfig.insertVariable"),
	variablesLabel: ts("aiConfig.variablesLabel"),
	allowedValuesTitle: ts("aiConfig.allowedValuesTitle"),
	allowedValuesEmpty: ts("aiConfig.allowedValuesEmpty"),
	fallbackLabel: ts("aiConfig.fallbackLabel"),
	fallbackHelp: ts("aiConfig.fallbackHelp"),
	leaveEmpty: ts("aiConfig.leaveEmpty"),
	behaviorTitle: ts("aiConfig.behaviorTitle"),
	syncReasoningLabel: ts("aiConfig.syncReasoningLabel"),
	syncReasoningHelp: ts("aiConfig.syncReasoningHelp"),
	syncReasoningTargetLabel: ts("aiConfig.syncReasoningTargetLabel"),
	syncReasoningTargetHelp: ts("aiConfig.syncReasoningTargetHelp"),
	syncSourceLabel: ts("aiConfig.syncSourceLabel"),
	syncSourceHelp: ts("aiConfig.syncSourceHelp"),
	syncSourceTargetLabel: ts("aiConfig.syncSourceTargetLabel"),
	syncSourceTargetHelp: ts("aiConfig.syncSourceTargetHelp"),
	secondaryTargetPlaceholder: ts("aiConfig.secondaryTargetPlaceholder"),
	testTitle: ts("aiConfig.testTitle"),
	freeDuringSetup: ts("aiConfig.freeDuringSetup"),
	testIntroTitle: ts("aiConfig.testIntroTitle"),
	testIntroHelp: ts("aiConfig.testIntroHelp"),
	prospectLabel: ts("aiConfig.prospectLabel"),
	prospectPlaceholder: ts("aiConfig.prospectPlaceholder"),
	loadVariables: ts("aiConfig.loadVariables"),
	variablesPreviewTitle: ts("aiConfig.variablesPreviewTitle"),
	noVariables: ts("aiConfig.noVariables"),
	editData: ts("aiConfig.editData"),
	revertEdits: ts("aiConfig.revertEdits"),
	runTest: ts("aiConfig.runTest"),
	rerunTest: ts("aiConfig.rerunTest"),
	testRunHelp: ts("aiConfig.testRunHelp"),
	progressLabel: ts("aiConfig.progressLabel"),
	loadingLeadData: ts("aiConfig.loadingLeadData"),
	loadingResearch: ts("aiConfig.loadingResearch"),
	loadingAnalyze: ts("aiConfig.loadingAnalyze"),
	loadingReturn: ts("aiConfig.loadingReturn"),
	resultTitle: ts("aiConfig.resultTitle"),
	resultReadyTitle: ts("aiConfig.resultReadyTitle"),
	valueLabel: ts("aiConfig.valueLabel"),
	reasoningLabel: ts("aiConfig.reasoningLabel"),
	sourcesLabel: ts("aiConfig.sourcesLabel"),
	durationLabel: ts("aiConfig.durationLabel"),
	fallbackUsed: ts("aiConfig.fallbackUsed"),
	finalPrompt: ts("aiConfig.finalPrompt"),
	emptyState: ts("aiConfig.emptyState"),
	noCredits: ts("aiConfig.noCredits"),
	costReminder: ts("aiConfig.costReminder"),
	cancel: ts("aiConfig.cancel"),
	save: ts("aiConfig.save"),
	requiredPrompt: ts("aiConfig.requiredPrompt"),
	requiredSecondaryField: ts("aiConfig.requiredSecondaryField"),
	invalidFallback: ts("aiConfig.invalidFallback"),
	testError: ts("aiConfig.testError"),
});
